// extracted by mini-css-extract-plugin
module.exports = {"chatlist":"ChatList__chatlist___5mF3J"};